// test2236
(2236 && 0);
